import {resource} from 'aurelia-orm';
import {AppEntity} from "./app-entity";

@resource('comment')
export class Comment extends AppEntity {
	content: string;
}